import { initials } from "@/lib/format";

export function Avatar({
  name,
  email,
  src,
  size = "md",
}: {
  name: string | null;
  email: string;
  src?: string | null;
  size?: "md" | "lg";
}) {
  return (
    <span className={["avatar", size === "lg" && "avatar--lg"].filter(Boolean).join(" ")}>
      {src ? (
        <img src={src} alt="" loading="lazy" referrerPolicy="no-referrer" />
      ) : (
        <span aria-hidden>{initials(name, email)}</span>
      )}
    </span>
  );
}
